module.exports = __webpack_public_path__ + "img/bg-about-sec1.a9b8ee4b.png";